import { render, staticRenderFns } from "./NsTab.vue?vue&type=template&id=1e27b81a&"
import script from "./NsTab.vue?vue&type=script&lang=js&"
export * from "./NsTab.vue?vue&type=script&lang=js&"
import style0 from "./NsTab.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports